<template>
  <section>
    <div class="cookies_header">
      DJULI - PROVIDED BY ZIMMER AND PEACOCK AS - TERMS OF USE
    </div>
    <br>

    <div class="cookies_subsection">
      These Terms of Use ("ToU") applies to your access to and use of the djuli
      data management system provided by Zimmer and Peacock AS ("ZP"). All use of
      Djuli is subject to these ToU.
    </div>
    <section>
      <div class="question">
        GENERAL
      </div>
      <div class="answer">
        These ToU governs the User's use of duli, and relevant content and
        documentation made available by ZP therein ("Content"), including any
        releases and/or updates of djuli and the Content. If the User does not
        read and agree to be bound by the terms and conditions defined in these
        ToU, the User is not permitted to use djuli or the Content in any way
        whatsoever.
      </div>
      <div class="subanswer">
        Djuli is a database with tools that the User can use to upload, store,
        analyse and share technical data, from different data sources, including
        electrochemical sensors. Djuli may not be used for any other purposes than
        set out in these ToU or the Content.
      </div>
      <div class="question">
        LICENCE GRANT
      </div>
      <div class="answer">
        Subject to the terms and conditions in these ToU, ZP grants to the User a
        limited, non-exclusive, non-transferable, non-sublicensable right to
        access and use Djuli and the Content in accordance with these ToU and for
        non-commercial purposes.
      </div>

      <div class="question">
        USER LOGIN
      </div>
      <div class="answer">
        The User may create a Djuli account. As part of the registration process,
        the User is asked to choose a username and password for identification
        purposes ("Login Information").
      </div>
      <div class="subanswer">
        The User’s Login Information is personal and confidential and should not
        be shared with any third parties. The User is responsible for any damages
        or loss arising out the Login Information being disclosed to and/or used
        by any third party.
      </div>
      <div class="subanswer">
        The User agrees to notify ZP about any unauthorized use of the Login
        Information as soon as possible after becoming aware of such use.
      </div>

      <div class="question">
        CONDITIONS FOR USE
      </div>
      <div class="answer">
        Authorised Users shall use Djuli in accordance with these ToU and Content
        provided by ZP. The User is responsible for all their activity within
        Djuli.
      </div>
      <div class="subanswer">
        Users shall not, and shall not allow any third party to, unless explicitly
        stated in these ToU:
      </div>
      <div class="subanswer">
        <ul>
          <li>
            decompile, disassemble, reverse engineer or otherwise attempt to
            obtain or perceive the source code from any component of Djuli
          </li>
          <li>
            allow third parties to gain access to Djuli, or sublicense, transfer,
            sell or otherwise assign its account at Djuli to any third party
          </li>
          <li>
            alter, embed into any other product or otherwise create derivative
            works of, or otherwise modify Djuli
          </li>
          <li>
            interfere with or disrupt the integrity of Djuli, software or data
          </li>
          <li>attempt to gain unauthorized access</li>
          <li>interfere with another User's use of Djuli</li>
        </ul>
        Users shall not, and shall not allow any third party to, unless explicitly
        stated in these ToU:
      </div>

      <div class="question">
        AVAILABILITY
      </div>
      <div class="answer">
        Djuli is provided by ZP on a “best effort” basis. The User accepts that
        Djuli from time to time may be partly or completely unavailable due to
        amongst others maintenance and unforeseen events. ZP does not warrant or
        guarantee any minimum availability of Djuli or assume any liability for
        damages or loss caused by downtime or other circumstances.
      </div>

      <div class="question">
        AVAILABILITY
      </div>
      <div class="answer">
        Djuli is still under development by ZP, and the functionality and content
        included therein may be changed without notice to the User. ZP reserves
        the right to change vendors or hosting partners and modify, remove or
        correct any data, design, functionalities or tools contained etc. in Djuli
        at any time, in its sole discretion and without prior notification.
      </div>
      <div class="question">
        PRIVACY
      </div>
      <div class="answer">
        In order to provide Djuli, ZP may process personal data about the Users.
        Please refer to the privacy policy for more information about how ZP
        process personal data, which is found here
      </div>
      <div class="question">
        INTELLECTUAL PROPERTY RIGHTS
      </div>
      <div class="answer">
        Djuli, the Content, and all intellectual property rights developed by ZP
        provided or made available to the User are the exclusive property of ZP
        ("ZP IP"). ZP retains all right, title and interest in and to the ZP IP,
        including all including all inventions, patents, designs, copyright, trade
        secrets, tools, software, know-how, brand names, trademarks, and any other
        industrial and/or intellectual property rights. User acknowledges that it
        neither owns nor acquires any rights in or to the ZP IP, other than the
        usage rights expressly granted in these ToU. The User shall indemnify and
        keep indemnified ZP from and against any third party claims against ZP
        arising or relating to the exhibition, dissemination or publication by the
        User of any matter in any way included in or founded upon Djuli.
      </div>
      <div class="question">
        TERMINATION AND SUSPENSION OF Djuli
      </div>
      <div class="answer">
        A User has the right to cancel its registration at any time. ZP may
        suspend or terminate these ToU without cause with 14 days’ notice. ZP may,
        without notice and with immediate effect terminate, suspend or restrict
        the User's access and use of Djuli, if there is a suspected violation of
        these ToU, or illegal or fraudulent use of Djuli. ZP may also suspend or
        cease providing Djuli upon its decision to discontinue provision of Djuli
        or other reasonable grounds, e.g. if suspension or closure is necessary
        due to security reasons, improper use of the Djuli etc.
      </div>
      <div class="question">
        LIABILITY
      </div>
      <!-- <div class="answer">
      Djuli and the Content are provided "as is". To the extent permitted by
      law, ZP and its suppliers disclaim all warranties, either expressed or
      implied, statutory or otherwise, including without limitation warranties
      of functionality, fitness for a particular purpose accuracy, completeness,
      or non-infringement. ZP does not warrant that Djuli will be error-free,
      that the use of Djuli will be uninterrupted or error-free, or that Djuli
      does not contain any viruses.
    </div> -->
      <div class="subanswer">
        ZP, its consultants, employees, or suppliers shall in no event be liable
        to the User, or any third party for any loss or damage, whether direct,
        indirect, special, punitive, incidental or consequential damage of any
        nature, including but not limited to, damages or costs due to damage to
        hardware, interruption of business or loss of profits, data, revenue,
        goodwill, production, use or the like. The User is fully and solely
        responsible for the use of the data and for any results and consequences
        of this use.
      </div>
      <div class="question">
        AMENDMENTS TO THE TOU
      </div>
      <div class="answer">
        ZP reserves the right to update or change these ToU its sole discretion.
        Unless stated otherwise, amendments shall take effect immediately
        following posting of the new ToU. The current ToU will be available at
        here at all times, and we recommend that you review the ToU regularly.
        Please note that the continued use of Djuli after any updates are
        effectuated [or after receipt of notice of any changes], will constitute
        acceptance of those updates/changes and the User will be bound by the new
        terms upon the continued use of Djuli. If the User does not accept the
        changes, the User may terminate its account at Djuli with immediate
        effect.
      </div>
      <div class="question">
        ASSIGNMENT
      </div>
      <div class="answer">
        By registering as a user on Djuli, you accept and agree that ZP, either
        partly or in whole, may assign its rights and obligations under these ToU
        to a third party.
      </div>
      <div class="question">
        PRIVILEGES AND IMMUNITIES
      </div>
      <div class="answer">
        Nothing in or relating to these ToU shall be deemed or interpreted as a
        waiver of any privileges and immunities accorded to ZP.
      </div>
      <div class="question">
        GOVERNING LAW AND DISPUTES
      </div>
      <div class="answer">
        These ToU shall be governed by and construed in accordance with the laws
        of Norway. All actions or proceedings arising under or related to these
        ToU must be brought in the relevant court at the place of business of ZP.
      </div>
      <div class="question">
        NOTICES AND CONTACT INFORMATION
      </div>
      <div class="answer">
        In case of questions relating to these ToU and Djuli, please direct a
        request to <span @click="contactSupport">Contact Support</span> ZP may
        notify the User on his account page or by email to the email address that
        the User has provided to ZP through Djuli.
      </div>
      <br>
      <br>
      <br>
      <div class="lastupdated">
        Last upated : 2021.02.08
      </div>
    </section>
  </section>
</template>

<script>
export default {
  methods:{
    contactSupport(){
     let url='https://www.zimmerpeacocktech.com/contact-support/'
      window.open(url,'_blank')
    }
  }
};
</script>

<style scoped>
span{
  color: var(--djuli-secondary-color);
  cursor: pointer;
}
.question {
  padding: 15px 0;
  font-weight: bold;
  color: var(--djuli-primary-color);
}
.type {
  padding: 8px 0;
  font-weight: 500;
  text-decoration: underline;
  text-align: justify;
}
.answer,
.subanswer {
  text-align: justify;
}
.subanswer {
  padding: 12px 0;
}
.cookies_header {
  background: whitesmoke;
  padding: 1rem;
  color: var(--blue-marguerite);
  text-transform: uppercase;
}
section {
  padding:1rem 2rem;
}
.cookies_subsection {
  padding: 0 2rem;
}
</style>